module.exports = __webpack_public_path__ + "img/img4.793a9042.png";